// Pinned fixture values are only for local/demo fallback routes and reset tooling.
export const DEMO_FIXTURE_CLIENT_SLUG = "carrefour-express-ma";
export const DEMO_FIXTURE_MONTH = "2026-07";
